module.exports = "https://coursera_assets.s3.amazonaws.com/images/5f44d3cc170f76b9fadb15e8592d4411.png";